const config = {
	"gatsby": {
		"pathPrefix": "/",
		"siteUrl": "https://learn.hasura.io",
		"gaTrackingId": null
	},
	"header": {
		"logo": "",
		"title": "DS Platform Gitbook",
		"githubUrl": "https://github.com/dpytka/dsplatform-documentation",
		"helpUrl": "",
		"tweetText": "",
		"links": [
			{ "text": "", "link": ""}
		],
	},
	"sidebar": {
		"forcedNavOrder": [
			"/introduction",
    		"/codeblock"
		],
		"links": [
			{ "text": "", "link": ""},
		],
		"frontline": false,
		"ignoreIndex": true,
	},
	"siteMetadata": {
		"title": "DS Platform Gitbook",
		"description": "Documentation built with mdx. Powering www.defensive-security.com/ ",
		"ogImage": null,
		"docsLocation": "https://github.com/dpytka/dsplatform-documentation/tree/master/content",
		"favicon": "https://graphql-engine-cdn.hasura.io/img/hasura_icon_black.svg"
	},
};

module.exports = config;